import React from 'react';

import { Box, xcss } from '@atlaskit/primitives';

type VideoPlayerProps = {
	url: string;
	title: string;
};

const containerStyles = xcss({
	aspectRatio: '16 / 9',
});

// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Video player__
 *
 * A video player {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export const VideoPlayer = ({ url, title }: VideoPlayerProps) => {
	return (
		<Box xcss={containerStyles}>
			<iframe
				width="100%"
				height="100%"
				src={url}
				title={title}
				frameBorder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
				referrerPolicy="strict-origin-when-cross-origin"
				allowFullScreen
			/>
		</Box>
	);
};
